// Empty stub for optional formstone scrollbar module
// This module is intentionally empty as we don't want to use scrollbar functionality
module.exports = {}; 
